module.exports = __webpack_public_path__ + "static/media/Y5.4e4c4fcb.mp3";